import React from 'react';
import AmExImg from '../../images/AmericanExpress-light.png';
import DiscoverImg from '../../images/Discover-light.png';
import MastercardImg from '../../images/MasterCard-light.png';
import VisaImg from '../../images/Visa-light.png';

// Define styles directly in the component to avoid module resolution issues
const styles = {
  logosContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: '1rem',
  },
  logo: {
    maxHeight: '30px',
    margin: '0 0.5rem 0 0',
  },
};

interface CreditCardLogosProps {
  className?: string;
}

/**
 * A reusable component to display credit card logos
 * Used in various payment forms throughout the application
 */
const CreditCardLogos: React.FC<CreditCardLogosProps> = ({
  className = '',
}) => {
  return (
    <div className={className} style={styles.logosContainer}>
      <img src={VisaImg} style={styles.logo} alt="Visa" />
      <img src={MastercardImg} style={styles.logo} alt="Mastercard" />
      <img src={DiscoverImg} style={styles.logo} alt="Discover" />
      <img src={AmExImg} style={styles.logo} alt="American Express" />
    </div>
  );
};

export default CreditCardLogos;
